import { useEffect } from 'react';
import FJImageToImageLeftContainer from './FJImageToImageLeft/FJImageToImageLeftContainer.jsx';
import FJImageToImageRightContainer from './FJImageToImageRight/FJImageToImageRightContainer.jsx';
import FJActionImageToImage from '../../redux/action/FJActionImageToImage.js';
import { useDispatch } from 'react-redux';
//本地字体调试

function FJImageToImage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(FJActionImageToImage.loadImageToImagePageAction());
    });
    return (
        <>
            <FJImageToImageLeftContainer />
            <FJImageToImageRightContainer />
        </>
    );
}

export default FJImageToImage;
